import React, { useState } from 'react';
import { IMG_FALLBACK } from '../../utils/format';

// Resilient game image with a 3-stage fallback chain:
//  1. primary CDN URL (images.weserv.nl — resolves where rbxcdn does not)
//  2. same-origin /img/ proxy (cached bytes served from our own domain)
//  3. inline placeholder (never a broken-image icon)
export const GameImg: React.FC<{
  src: string | null;
  altSrc?: string | null;
  alt: string;
  className?: string;
  eager?: boolean;
}> = ({ src, altSrc, alt, className, eager }) => {
  const [stage, setStage] = useState(0);
  const cur = stage === 0 ? src : stage === 1 ? altSrc : null;
  if (!cur) {
    return <img src={IMG_FALLBACK} alt={alt} className={className} />;
  }
  return (
    <img
      src={cur}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      referrerPolicy="no-referrer"
      onError={() => setStage((s) => (s === 0 && altSrc ? 1 : 2))}
      className={className}
    />
  );
};
